export default "__VITE_ASSET__aaee4d8d__"